import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon, HeartIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const cardWidth = track.scrollWidth / testimonials.length;
      setActive(Math.round(track.scrollLeft / cardWidth));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const cardWidth = track.scrollWidth / testimonials.length;
    track.scrollTo({
      left: cardWidth * index,
      behavior: 'smooth'
    });
  };
  const step = (direction: -1 | 1) => {
    const next = Math.min(testimonials.length - 1, Math.max(0, active + direction));
    scrollTo(next);
  };
  return <section className="w-full py-12 sm:py-16" aria-labelledby="testimonios-title" data-id="element-170" data-mp="m4rowevdji7h">
      <div className="mx-auto max-w-6xl px-6" data-id="element-171" data-mp="78abli3mjtia">
        <div className="mx-auto max-w-2xl text-center" data-id="element-172" data-mp="79bqxyrob25t">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-oliva" data-id="element-173" data-mp="c6bua1x51qt8">
            Testimonios
          </p>
          <h2 id="testimonios-title" className="font-display text-3xl font-semibold tracking-tight text-tinta sm:text-4xl" data-id="element-174" data-mp="zxqzc2gaum86">
            Más de 1.200 jugadores ya entrenan su mente
          </h2>
        </div>

        <div className="relative mt-10" data-id="element-175" data-mp="v5ptay9q5rql">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-5 overflow-x-auto px-1 pb-4" data-id="element-176" data-mp="v4o5dt7m1arg">
            {testimonials.map(t => <article key={t.name} className="w-[85%] shrink-0 snap-center overflow-hidden rounded-4xl bg-white shadow-soft sm:w-[46%] lg:w-[31.5%]" data-id="element-177" data-mp="1nmabwu6dtl62">
                <div className="flex items-center gap-3 border-b border-salvia/30 px-6 py-4" data-id="element-178" data-mp="1sinzam6sqiuh">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-bosque font-display text-base font-semibold text-white" data-id="element-179" data-mp="1ogj9jyjgy6d4">
                    {t.name.charAt(0)}
                  </span>
                  <span data-id="element-180" data-mp="1ejwrfhij1tes">
                    <span className="block text-sm font-semibold text-tinta" data-id="element-181" data-mp="1ekfz85egr1f3">
                      {t.name}, {t.age}
                    </span>
                    <span className="block text-xs text-tinta/50" data-id="element-182" data-mp="14stpkdhrxaeg">
                      {t.city}
                    </span>
                  </span>
                </div>

                <div className="bg-agua/10 px-6 py-10" data-id="element-183" data-mp="10px3udwxsy6a">
                  <QuoteIcon className="mb-4 h-6 w-6 text-oliva" strokeWidth={1.6} aria-hidden="true" data-id="element-184" data-mp="vrc2gb5y88g9" />
                  <p className="font-display text-lg leading-relaxed text-tinta" data-id="element-185" data-mp="32hp48xes83ll">
                    “{t.quote}”
                  </p>
                </div>

                <div className="flex items-center gap-4 px-6 py-4" data-id="element-186" data-mp="37htpf0qmxmi5">
                  <HeartIcon className="h-5 w-5 fill-[#C56A6A] text-[#C56A6A]" strokeWidth={1.5} aria-hidden="true" data-id="element-187" data-mp="3cfld1ik8ymgj" />
                  <span className="flex" aria-hidden="true" data-id="element-188" data-mp="2jrzb0eqo3pvs">
                    {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-oliva text-oliva" strokeWidth={1.5} data-id="element-189" data-mp="2opr256jhn7yx" />)}
                  </span>
                  <span className="ml-auto text-xs font-medium uppercase tracking-[0.14em] text-tinta/40" data-id="element-190" data-mp="210g9ydg7elwe">
                    Alumno verificado
                  </span>
                </div>
              </article>)}
          </div>

          <div className="mt-8 flex items-center justify-center gap-6" data-id="element-191" data-mp="1lxerxf3wwb1i">
            <button type="button" onClick={() => step(-1)} aria-label="Testimonio anterior" className="flex h-11 w-11 items-center justify-center rounded-full border border-salvia/60 bg-white text-bosque transition-colors hover:bg-salvia/20 disabled:opacity-40" disabled={active === 0} data-id="element-192" data-mp="1gylhjvjx905k">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-193" data-mp="1zojxsyxvhzka" />
            </button>

            <div className="flex items-center gap-2" data-id="element-194" data-mp="2elkdg42si42e">
              {testimonials.map((t, index) => <button key={t.name} type="button" onClick={() => scrollTo(index)} aria-label={`Ver testimonio de ${t.name}`} className={`h-2 rounded-full transition-all duration-300 ${active === index ? 'w-7 bg-bosque' : 'w-2 bg-salvia'}`} data-id="element-195" data-mp="29mqzybni6d28" data-mpi={index} />)}
            </div>

            <button type="button" onClick={() => step(1)} aria-label="Testimonio siguiente" className="flex h-11 w-11 items-center justify-center rounded-full border border-salvia/60 bg-white text-bosque transition-colors hover:bg-salvia/20 disabled:opacity-40" disabled={active === testimonials.length - 1} data-id="element-196" data-mp="2vv68xtyre3zp">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-197" data-mp="2c7fbgc48c460" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}